export const bigNumberFormatter = (n: number) => {
  const formatter = Intl.NumberFormat("pt-BR", { notation: "compact" });
  return formatter.format(n);
};
